module.exports = __webpack_public_path__ + "media/images/pc/specials/fair_event/slider/image3-1f096dca640a20e94ce59cb382bb57d4.jpg";